import { useDashboardFeatureFlags } from '@components';
import { useCancelSubscriptionPlanMutation } from '../queries/useCancelSubscriptionPlanMutation';
import { useCurrentSubscriptionQuery } from '../queries/useCurrentSubscriptionQuery';
import { useUndoCancelSubscriptionPlanMutation } from '../queries/useUndoCancelSubscriptionPlanMutation';
export const useSubscription = () => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { currentSubscriptionQuery, invalidateCurrentSubscriptionQuery } = useCurrentSubscriptionQuery(undefined, {
        enabled: dashboardFeatureFlags.subscriptions.enabled,
        refetchInterval: (data) => {
            if (data?.pendingSubscription)
                return 1_000;
            return false;
        },
    });
    const { cancelSubscriptionPlanMutationMutation } = useCancelSubscriptionPlanMutation();
    const { undoCancelSubscriptionPlanMutationMutation } = useUndoCancelSubscriptionPlanMutation();
    const getIfHasLimit = (attribute) => {
        if (!currentSubscriptionQuery.data)
            return false;
        return currentSubscriptionQuery.data.plan[`${attribute}Limit`] !== -1;
    };
    const getIfLimitReached = (attribute) => {
        if (!currentSubscriptionQuery.data)
            return true;
        if (!getIfHasLimit(attribute))
            return false;
        return (currentSubscriptionQuery.data[attribute].usage >=
            currentSubscriptionQuery.data.plan[`${attribute}Limit`]);
    };
    const cancelActiveSubscription = async () => {
        await cancelSubscriptionPlanMutationMutation.mutateAsync([]);
        invalidateCurrentSubscriptionQuery();
    };
    const undoCancelActiveSubscription = async () => {
        await undoCancelSubscriptionPlanMutationMutation.mutateAsync([]);
        invalidateCurrentSubscriptionQuery();
    };
    return {
        // TODO: calculate it better when we have more data
        hasActiveProSubscription: currentSubscriptionQuery.data && currentSubscriptionQuery.data?.plan.pro,
        currentSubscriptionQuery,
        activeSubscription: currentSubscriptionQuery.data,
        pendingSubscription: currentSubscriptionQuery.data?.pendingSubscription,
        canUpgradeSubscription: dashboardFeatureFlags.subscriptions.enabled &&
            currentSubscriptionQuery.data &&
            currentSubscriptionQuery.data?.plan.upgradable,
        customDomains: {
            hasLimit: getIfHasLimit('domains'),
            canCreate: !dashboardFeatureFlags.subscriptions.enabled || !getIfLimitReached('domains'),
        },
        offers: {
            hasLimit: getIfHasLimit('offers'),
            canCreate: !dashboardFeatureFlags.subscriptions.enabled || !getIfLimitReached('offers'),
            threshold: 5,
        },
        teamMembers: {
            hasLimit: getIfHasLimit('members'),
            canCreate: !dashboardFeatureFlags.subscriptions.enabled || !getIfLimitReached('members'),
            threshold: 1,
        },
        isLoading: currentSubscriptionQuery.isLoading,
        subscriptionData: currentSubscriptionQuery.data,
        invalidateSubscriptionData: invalidateCurrentSubscriptionQuery,
        cancelActiveSubscription,
        undoCancelActiveSubscription,
    };
};
